
import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext({});

export const LanguageProvider = ({ children }) => {
    // Get language from localStorage or default to 'en'
    const [language, setLanguage] = useState(() => {
        return localStorage.getItem('selectedLanguage') || 'en';
    });

    // Available languages
    const availableLanguages = [
        { code: 'en', name: 'English', nativeName: 'English' },
        { code: 'ar', name: 'Arabic', nativeName: 'العربية' }
    ];

    // Switch language and save to localStorage
    const switchLanguage = (languageCode) => {
        setLanguage(languageCode);
        localStorage.setItem('selectedLanguage', languageCode);

        // Update document direction for Arabic
        if (languageCode === 'ar') {
            document.documentElement.dir = 'rtl';
            document.documentElement.lang = 'ar';
        } else {
            document.documentElement.dir = 'ltr';
            document.documentElement.lang = 'en';
        }
    };

    // Initialize direction on mount
    useEffect(() => {
        if (language === 'ar') {
            document.documentElement.dir = 'rtl';
            document.documentElement.lang = 'ar';
        } else {
            document.documentElement.dir = 'ltr';
            document.documentElement.lang = 'en';
        }
    }, []);

    // Get current language info
    const getCurrentLanguage = () => {
        return availableLanguages.find(lang => lang.code === language) || availableLanguages[0];
    };

    // Check if current language is RTL
    const isRTL = () => {
        return language === 'ar';
    };

    const value = {
        language,
        switchLanguage,
        availableLanguages,
        getCurrentLanguage,
        isRTL
    };

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};

export default LanguageContext;
